/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SuppliesInputs */

const en_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supplies`)
};

const es_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suministros`)
};

const fr_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournitures`)
};

const de_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zubehör`)
};

const ja_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ペット用品`)
};

const zh_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`宠物用品`)
};

const ar_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستلزمات`)
};

const id_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlengkapan`)
};

const it_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessori / Forniture`)
};

const ru_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары для животных`)
};

const pt_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suprimentos`)
};

const ko_val_supplies = /** @type {(inputs: Val_SuppliesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`반려동물 용품`)
};

/**
* | output |
* | --- |
* | "Supplies" |
*
* @param {Val_SuppliesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_supplies = /** @type {((inputs?: Val_SuppliesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SuppliesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_supplies(inputs)
	if (locale === "es") return es_val_supplies(inputs)
	if (locale === "fr") return fr_val_supplies(inputs)
	if (locale === "de") return de_val_supplies(inputs)
	if (locale === "ja") return ja_val_supplies(inputs)
	if (locale === "zh") return zh_val_supplies(inputs)
	if (locale === "ar") return ar_val_supplies(inputs)
	if (locale === "id") return id_val_supplies(inputs)
	if (locale === "it") return it_val_supplies(inputs)
	if (locale === "ru") return ru_val_supplies(inputs)
	if (locale === "pt") return pt_val_supplies(inputs)
	return ko_val_supplies(inputs)
});